export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"robots","content":"index, follow"},{"name":"description","content":"Khám phá các sản phẩm chất lượng cao. Mua sắm online dễ dàng, giao hàng nhanh chóng."},{"name":"keywords","content":"thương mại điện tử, mua sắm online, sản phẩm chất lượng"},{"property":"og:type","content":"website"},{"property":"og:title","content":"Ecommerce Web - Trang thương mại điện tử"},{"property":"og:description","content":"Khám phá các sản phẩm chất lượng cao. Mua sắm online dễ dàng, giao hàng nhanh chóng."},{"property":"og:image","content":"/images/og-default.jpg"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Ecommerce Web - Trang thương mại điện tử"},{"name":"twitter:description","content":"Khám phá các sản phẩm chất lượng cao. Mua sắm online dễ dàng, giao hàng nhanh chóng."},{"name":"twitter:image","content":"/images/og-default.jpg"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"style":[],"script":[],"noscript":[],"titleTemplate":"%s","title":"Ecommerce Web - Trang thương mại điện tử"}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true